import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Sciences Physiques",
  icon: "🔬",
  tagline: "Approfondissez vos connaissances en physique théorique et expérimentale",
  duree: "3 à 5 ans",
  diplome: "Licence/Master",
  mode: "Présentiel",
  nombreDebouches: "9",
  description: "La filière Sciences Physiques propose une formation rigoureuse en physique fondamentale et appliquée. Notre programme allie cours théoriques et travaux pratiques pour former des physiciens compétents dans divers domaines scientifiques et technologiques.",
  objectifs: [
    "Maîtriser les lois fondamentales de la physique",
    "Développer des compétences expérimentales",
    "Comprendre les applications technologiques",
    "Acquérir une rigueur scientifique",
    "Préparer à la recherche ou l'enseignement"
  ],
  programme: [
    { titre: "Licence 1 & 2", matieres: ["Mécanique classique", "Électricité et magnétisme", "Optique", "Thermodynamique", "Mathématiques pour la physique", "Travaux pratiques"] },
    { titre: "Licence 3 & Master", matieres: ["Mécanique quantique", "Physique statistique", "Physique des matériaux", "Électronique", "Physique nucléaire", "Instrumentation scientifique"] }
  ],
  debouches: [
    { titre: "Enseignant", description: "Enseignement de la physique" },
    { titre: "Chercheur", description: "Recherche en physique" },
    { titre: "Ingénieur", description: "Applications technologiques" },
    { titre: "Technicien de laboratoire", description: "Expérimentation scientifique" },
    { titre: "Physicien médical", description: "Applications médicales" },
    { titre: "Expert en énergie", description: "Secteur énergétique" }
  ],
  competences: ["Maîtrise des lois physiques fondamentales", "Compétences expérimentales avancées", "Capacité de modélisation mathématique", "Rigueur scientifique", "Maîtrise de l'instrumentation"]
};

export default function SciencesPhysiques() {
  return <FiliereTemplate filiere={filiereData} />;
}